const facetsMenu = () => {
	$("html.js .no_submit").click(function (e) {
		e.preventDefault();
	});
	$(
		".open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask"
	).click(function () {
		$("#open_filters_menu").toggleClass("show_menu");
		$("body").toggleClass("overflow-hidden");
		$("body").toggleClass("open-filters");
		$(".shopify-section-header").toggleClass("low_index");
		$(".section-announcement").toggleClass("low_index");
	});
};

// Handle filter dropdowns - only one open at a time
const initFilterDropdowns = () => {
	const filterDetails = document.querySelectorAll('.facets__filter-details');
	
	if (filterDetails.length === 0) return;
	
	// Close other dropdowns when one is opened
	filterDetails.forEach((detail) => {
		detail.addEventListener('toggle', function() {
			if (this.hasAttribute('open')) {
				// Close all other filter dropdowns
				filterDetails.forEach((otherDetail) => {
					if (otherDetail !== this && otherDetail.hasAttribute('open')) {
						otherDetail.removeAttribute('open');
					}
				});
			}
		});
	});
	
	// Close dropdowns when clicking outside
	document.addEventListener('click', function(event) {
		const isClickInsideFilterDropdown = event.target.closest('.facets__filter-dropdown');
		
		// Only close if clicking completely outside the filter dropdown area
		if (!isClickInsideFilterDropdown) {
			filterDetails.forEach((detail) => {
				if (detail.hasAttribute('open')) {
					detail.removeAttribute('open');
				}
			});
		}
	});
};

document.addEventListener("DOMContentLoaded", function () {
	facetsMenu();
	initFilterDropdowns();
});
document.addEventListener("shopify:section:load", function () {
	facetsMenu();
	initFilterDropdowns();
});

let menu = document.querySelector(".facets-menu");

const sortBySelect = document.querySelector(".select__sort_by");
if (sortBySelect) {
	sortBySelect.addEventListener("click", function () {
		const sortBySvg = document.querySelector(".facets__sort-by svg");
		if (sortBySvg) {
			sortBySvg.classList.toggle("rotateSvg");
		}
	});
}
